const pkgProtection = document.querySelector('input[data-pkg-protection]');
const pkgProtectionProductId = pkgProtection.getAttribute('data-product-id');
const pkgProtectionPrice = document.querySelector('.cart-popup__pkg-protection--price');
const cartPopupContainer = document.querySelector('[data-cart-popup]');
var pkgpVariantId = pkgProtection.getAttribute('data-variant-id');
var previouspkgpVariantId = pkgpVariantId;
var pkgProtectionPriceText = pkgProtectionPrice.innerText;
var pkgpVariantPrice = pkgProtection.getAttribute('data-variant-price');
var matchedTier = '';

document.addEventListener('DOMContentLoaded', function (event) {
    if (sessionStorage.getItem("pkg_optout") == 'true') {
        pkgProtection.checked = false;
    }
    handleCartUpdate();
    handlePkgpToggle();
});

document.addEventListener('cart:update', function (event) {
    console.log(`cart:update event!`);
    handleCartUpdate();
});

function handleCartUpdate() {
    $.getJSON('/cart.js', function (cart) {
        pkgpVariantId = pkgProtection.getAttribute('data-variant-id');

        if (packageProtectionTiers.length > 0 && cart.original_total_price > 0) {
            if(localStorage.getItem("matched_tier") !== null && localStorage.getItem("matched_tier") !== '' && localStorage.getItem("matched_tier") !== undefined) {
                matchedTier = JSON.parse(localStorage.getItem("matched_tier"));
            }
            else {
                matchedTier = handlePkgpTiers(cart.original_total_price);
                localStorage.setItem("matched_tier", JSON.stringify(matchedTier));
            }

            if(matchedTier) {
                pkgpVariantId = matchedTier?.variant_id;
                pkgProtectionPriceText = theme.Currency.formatMoney(matchedTier?.variant_price, theme.moneyFormat.replace(/\{\{.*?\}\}/, '{{amount_no_decimals}}'))
                pkgpVariantPrice = matchedTier?.variant_price;
            }
        }

        const variantFound = cart.items.filter((item) => parseInt(item.variant_id) == parseInt(pkgpVariantId))[0];

        if(variantFound && cart.items.length == 1) {
            cartPopupContainer.classList.add('loading');
            updateCartItem(pkgpVariantId, 0);
            cartPopupContainer.classList.remove('loading');
            localStorage.removeItem("matched_tier");
        }
      
        if ((!variantFound || variantFound == undefined) && pkgProtection.checked) {
          if(cart.items.length > 1) {
            pkgpAddtoCart(pkgpVariantId, cart);
            if (previouspkgpVariantId != pkgpVariantId) {
                updateCartItem(previouspkgpVariantId, 0);
            }
          }
          else if(cart.items.length == 1) {
            pkgpAddtoCart(pkgpVariantId, cart);
          }
        }
        
        pkgProtection.setAttribute('data-variant-id', pkgpVariantId);
        pkgProtection.setAttribute('data-variant-price', pkgpVariantPrice);
        pkgProtectionPrice.innerText = pkgProtectionPriceText;
        
        previouspkgpVariantId = pkgProtection.getAttribute('data-variant-id');

        if (variantFound?.quantity > 1) {
            updateCartItem(pkgpVariantId, 1);
        }
    });
}

function handlePkgpToggle() {
    document.addEventListener('click', function (event) {
        if (event.target == pkgProtection) {
            $.getJSON('/cart.js', function (cart) {
                pkgpVariantId = pkgProtection.getAttribute('data-variant-id');
                previouspkgpVariantId = pkgpVariantId;

                if (pkgProtection.checked) {
                    if (previouspkgpVariantId != pkgpVariantId) {
                        updateCartItem(previouspkgpVariantId, 0);
                    }
                    pkgpAddtoCart(pkgpVariantId, cart);
                    sessionStorage.setItem("pkg_optout", "false");
                }
                else {
                    updateCartItem(pkgpVariantId, 0);
                    sessionStorage.setItem("pkg_optout", "true");
                }
            });
        }
    });
}

function handlePkgpTiers(cartTotal) {

    let matchedTier = null;
    let cartTotalPrice = cartTotal;
    const pkgpVariantPrice = pkgProtection.getAttribute('data-variant-price');

    cartTotalPrice = cartTotalPrice - pkgpVariantPrice;

    packageProtectionTiers.forEach(tier => {
        const lowerLimit = parseFloat(tier.lower_limit);
        const upperLimit = tier.upper_limit ? parseFloat(tier.upper_limit) : null;

        if (!upperLimit || upperLimit == '0.0' || upperLimit == '0') {
            if (cartTotalPrice >= lowerLimit) {
                matchedTier = tier;
            }
        }
        else if (cartTotalPrice >= lowerLimit && cartTotalPrice <= upperLimit) {
            matchedTier = tier;
        }
    });
    console.log(`handlePkgpTiers matchedTier: ${JSON.stringify(matchedTier)}`)
    return matchedTier;
}

function pkgpAddtoCart(variantId, cart) {

    var params = {
        items: [{ 'id': variantId, 'quantity': 1 }]
    }
  
    cartPopupContainer.classList.add('loading');
    $.post('/cart/add.js', params)
    .done(
        function (response) {
            theme.CartDrawer.updateCart(false, true);
            cartPopupContainer.classList.remove('loading');
        }.bind(this)
    )
    .fail(
        function () {
            theme.CartDrawer.updateCart(false, true);
            cartPopupContainer.classList.remove('loading');
        }.bind(this)
    );

}

function updateCartItem(variantId, qty) {
    cartPopupContainer.classList.add('loading');
    $.getJSON('/cart.js', function(cart) {
        let lineItemKey = null;

        for (let i = 0; i < cart.items.length; i++) {
            if (cart.items[i].variant_id == variantId) {
                lineItemKey = cart.items[i].key;
                break;
            }
        }

        if (lineItemKey) {
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: {
                    'id': lineItemKey,
                    'quantity': parseInt(qty)
                },
                dataType: 'json',
                success: function(cart) {
                    theme.CartDrawer.updateCart(false, true);
                    cartPopupContainer.classList.remove('loading');
                },
                error: function(xhr, status, error) {
                    theme.CartDrawer.updateCart(false, true);
                    cartPopupContainer.classList.remove('loading');
                }
            });
        }
    });
}